<template>
  <section id="hero">
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/home-hero.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
    >
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center"
          height="100%"
          max-width="700"
          width="100%"
        >
          <base-heading title="CONNECT TO ANY DATABASES WITH TARANTULA" />

          <base-body>
            다수의 이기종 데이터베이스에 산재되어 있는 데이터를 한 곳에서 실시간 조회 할수 있는 방법을 찾고 계신가요? <br>
            이기종 데이터베이스간에 데이터를 주고 받을수 있는 데이터베이스 링크(DB LINK) 대체 솔루션을 찾고 계신가요?<br>
            이기종 데이터베이스간에 자유로이 데이터를 주고 받고 싶으신가요?<br>
            HTTP 방식으로 데이터베이스를 조회할수 있는 OPEN-API 구축 솔루션을 찾고 계신가요?<br><br>

            바로 여기에 그 해답이 있습니다.<br>
            "타란툴라" 를 소개합니다<br>
          </base-body>

          <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          >
            <base-btn>
              Tarantula: DB Gateway
            </base-btn>
            <!--
            <span class="font-weight-bold ml-6 mr-4 my-4">or</span>

            <base-btn
              :ripple="false"
              class="pa-1"
              height="auto"
              text
            >
              타란툴라를 소개합니다
            </base-btn>
            -->
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true },
    },

    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
    },
  }
</script>
